

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { getBookingDetailsServ } from "../../services/bookingDashboard.services";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getStatusOptions } from "../../utils/statusHelper";
import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";



/* ─── Scoped styles (same design language as OrderList) ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@500;600&display=swap');

  .od-root {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'DM Sans', 'Segoe UI', sans-serif;
  }

  /* ── Page header ── */
  .od-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 12px;
  }
  .od-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .od-back-btn {
    width: 38px; height: 38px;
    border-radius: 10px;
    border: 1px solid #e8e4e4;
    background: #fff;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    color: #555;
    transition: all 0.18s;
    font-size: 16px;
  }
  .od-back-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }
  .od-title {
    font-size: 20px;
    font-weight: 700;
    color: #1c0a0a;
    letter-spacing: -0.3px;
  }
  .od-subtitle {
    font-size: 12.5px;
    color: #828282;
    margin-top: 1px;
  }
  .od-invoice-btn {
    height: 40px;
    padding: 0 20px;
    border-radius: 10px;
    background: #a60808;
    color: #fff;
    border: none;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: flex; align-items: center; gap: 8px;
    transition: background 0.18s;
    letter-spacing: 0.2px;
  }
  .od-invoice-btn:hover { background: #a93226; }
  .od-invoice-btn i { font-size: 15px; }

  /* ── Grid layout ── */
  .od-grid {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 20px;
    align-items: start;
  }
  @media (max-width: 1024px) {
    .od-grid { grid-template-columns: 1fr; }
  }

  /* ── Card ── */
  .od-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .od-card-header {
    padding: 18px 22px;
    border-bottom: 1px solid #f7f5f5;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .od-card-title {
    font-size: 14px;
    font-weight: 700;
    color: #1c0a0a;
    letter-spacing: 0.1px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .od-card-title-icon {
    width: 28px; height: 28px;
    border-radius: 8px;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 14px;
    color: #a60808;
  }
  .od-card-body { padding: 22px; }

  /* ── Products table ── */
  .od-table { width: 100%; border-collapse: collapse; }
  .od-table thead tr { background: #fdf2f1; }
  .od-table th {
    padding: 12px 16px;
    font-size: 11px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    text-align: left;
    white-space: nowrap;
  }
  .od-table td {
    padding: 14px 16px;
    font-size: 13.5px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
  }
  .od-table tbody tr:hover td { background: #fdfafa; }

  .od-prod-cell { display: flex; align-items: center; gap: 14px; }
  .od-prod-img {
    width: 52px; height: 52px;
    border-radius: 10px;
    object-fit: cover;
    border: 1px solid #f0eded;
    flex-shrink: 0;
    background: #fdf2f1;
  }
  .od-prod-name { font-size: 13.5px; font-weight: 600; color: #1c0a0a; }
  .od-prod-tag {
    display: inline-block;
    font-size: 10px;
    font-weight: 600;
    color: #a60808;
    background: #fdf2f1;
    border-radius: 5px;
    padding: 2px 7px;
    margin-top: 4px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }
  .od-combo-items { margin-top: 6px; list-style: none; padding: 0; }
  .od-combo-items li {
    font-size: 11.5px;
    color: #777;
    background: #f9f9f9;
    border-radius: 6px;
    padding: 3px 8px;
    margin-bottom: 3px;
    display: inline-block;
    margin-right: 4px;
  }
  .od-price-main {
    font-size: 15px;
    font-weight: 700;
    color: #1c0a0a;
    font-family: 'JetBrains Mono', monospace;
  }
  .od-price-strike {
    font-size: 12px;
    color: #bbb;
    text-decoration: line-through;
    font-family: 'JetBrains Mono', monospace;
    margin-top: 2px;
  }
  .od-qty-badge {
    display: inline-flex; align-items: center; justify-content: center;
    width: 28px; height: 28px;
    border-radius: 8px;
    background: #fdf2f1;
    color: #a60808;
    font-weight: 700;
    font-size: 13px;
  }
  .od-total-cell {
    font-size: 14px;
    font-weight: 700;
    color: #1c0a0a;
    font-family: 'JetBrains Mono', monospace;
  }

  /* ── Amount summary ── */
  .od-summary {
    margin-top: 4px;
    padding: 16px 22px;
    background: #fdf2f1;
    border-top: 1px solid #f0eded;
  }
  .od-summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
    font-size: 13.5px;
    color: #666;
  }
  .od-summary-row.total {
    font-size: 15px;
    font-weight: 700;
    color: #1c0a0a;
    border-top: 1px solid #e8e2e2;
    margin-top: 6px;
    padding-top: 10px;
  }
  .od-summary-val {
    font-family: 'JetBrains Mono', monospace;
    font-weight: 600;
    color: #1c0a0a;
  }
  .od-summary-row.total .od-summary-val { color: #a60808; font-size: 16px; }

  /* ── Status tracker ── */
  .od-tracker { list-style: none; padding: 0; margin: 0; position: relative; }
  .od-tracker::before {
    content: '';
    position: absolute;
    left: 19px;
    top: 10px;
    bottom: 10px;
    width: 2px;
    background: linear-gradient(to bottom, #a60808, #f0c0b8);
    border-radius: 2px;
  }
  .od-tracker-item {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 10px 0;
    position: relative;
  }
  .od-tracker-icon {
    width: 40px; height: 40px;
    border-radius: 12px;
    background: #fff;
    border: 2px solid #a60808;
    display: flex; align-items: center; justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
    z-index: 1;
    box-shadow: 0 2px 8px rgba(192,57,43,0.12);
  }
  .od-tracker-label {
    font-size: 13.5px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1.2;
    padding-top: 2px;
  }
  .od-tracker-date {
    font-size: 11.5px;
    color: #828282;
    margin-top: 3px;
    font-family: 'JetBrains Mono', monospace;
  }

  /* ── Right column cards ── */
  .od-right-col { display: flex; flex-direction: column; gap: 16px; }

  /* info rows */
  .od-info-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 0;
    border-bottom: 1px solid #f7f5f5;
    font-size: 13.5px;
    color: #444;
  }
  .od-info-row:last-child { border-bottom: none; padding-bottom: 0; }
  .od-info-icon {
    width: 30px; height: 30px;
    border-radius: 8px;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    color: #a60808;
    font-size: 13px;
    flex-shrink: 0;
  }
  .od-info-label { font-size: 11px; color: #bbb; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
  .od-info-value { font-size: 13.5px; color: #1c0a0a; font-weight: 500; margin-top: 1px; }

  /* customer top area */
  .od-customer-top {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 18px;
  }
  .od-cust-avatar {
    width: 44px; height: 44px;
    border-radius: 12px;
    object-fit: cover;
    border: 2px solid #f0eded;
  }
  .od-cust-name { font-size: 15px; font-weight: 700; color: #1c0a0a; }
  .od-cust-role {
    font-size: 11px;
    color: #a60808;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-top: 2px;
  }

  /* payment ss badge */
  .od-ss-badge {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 12px; font-weight: 600; padding: 3px 10px; border-radius: 20px;
  }
  .od-ss-badge.up { background: #e8f8ef; color: #27ae60; }
  .od-ss-badge.no { background: #fdecea; color: #a60808; }
  .od-ss-eye {
    background: none; border: none; cursor: pointer;
    color: #2980b9; font-size: 14px; padding: 0 3px; vertical-align: middle;
  }

  /* divider */
  .od-divider {
    height: 1px; background: #f7f5f5; margin: 0 22px;
  }

  /* shipping chip */
  .od-ship-chip {
    display: inline-flex; align-items: center; gap: 6px;
    font-size: 12px; font-weight: 600;
    background: #fdf2f1; color: #a60808;
    padding: 4px 12px; border-radius: 20px;
    border: 1px solid #f0c0b8;
    margin-bottom: 14px;
  }

  /* mono value */
  .od-mono { font-family: 'JetBrains Mono', monospace; }

  /* skeleton */
  .od-skel-page { padding: 28px; background: #f5f5f7; min-height: 100%; }
`;

const OrderDetails = () => {

   const getImageUrl = (image) => {
      if (!image) return "";
      if (image.startsWith("http")) return image;
      return `${IMAGE_BASE_URL}${image}`;
    };
  

  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showSkelton, setShowSkelton] = useState(false);

  useEffect(() => { fetchOrderDetails(); }, [id]);

  const fetchOrderDetails = async () => {
    setShowSkelton(true);
    try {
      const res = await getBookingDetailsServ(id);
      setOrder(res?.data?.data);
    } catch (error) {
      console.error("Failed to fetch order details:", error);
    } finally {
      setShowSkelton(false);
    }
  };

  if (showSkelton) {
    return (
      <div className="bodyContainer">
        <style>{styles}</style>
        <Sidebar selectedMenu="Orders" selectedItem="Orders" />
        <div className="mainContainer">
          <TopNav />
          <div className="od-skel-page">
            <Skeleton height={38} width={280} borderRadius={10} style={{ marginBottom: 24 }} />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: 20 }}>
              <div>
                <Skeleton height={320} borderRadius={16} style={{ marginBottom: 20 }} />
                <Skeleton height={220} borderRadius={16} />
              </div>
              <div>
                <Skeleton height={160} borderRadius={16} style={{ marginBottom: 16 }} />
                <Skeleton height={160} borderRadius={16} style={{ marginBottom: 16 }} />
                <Skeleton height={180} borderRadius={16} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!order) return null;

  const user = order?.userId || {};
  const address = order?.address || {};
  const products = [
    ...(order?.product || []).map((item) => ({ ...item, type: "product" })),
    ...(order?.comboProduct || []).map((item) => ({ ...item, type: "comboProduct" })),
  ];

  const isPaymentUploaded = order?.paymentSs;

  const totalPaid =
    Number(order?.totalAmount) +
    (Number(order?.deliveryCharge) > 0 ? Number(order?.deliveryCharge) : 0);

  const formattedStatusFlow = order?.statusHistory?.map((log) => {
    const options = getStatusOptions(log.status, order?.shipping || order?.shippingMethod);
    const matched = options.find((o) => o.value === log.status);
    const iconMap = {
      pending: "🕓",
      ssRejected: "❗",
      approved: "💳",
      orderPlaced: "💳",
      orderPacked: "📦",
      outForDelivery: "📍",
      completed: "✅",
      cancelled: "❌",
    };
    return {
      key: log.status,
      icon: iconMap[log.status] || "⏳",
      label: matched ? matched.label : log.status,
      date: moment(log.updatedAt).format("ddd, DD MMM YYYY · h:mm A"),
    };
  });

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Orders" selectedItem="Orders" />
      <div className="mainContainer">
        <TopNav />
        <div className="od-root">

          {/* ── Page Header ── */}
          <div className="od-header">
            <div className="od-header-left">
              <button className="od-back-btn" onClick={() => navigate(-1)}>
                <i className="ti ti-arrow-left" />
              </button>
              <div>
                <div className="od-title">
                  Order #{order?.orderId?.slice(0, 8).toUpperCase()}
                </div>
                <div className="od-subtitle">
                  Placed on {moment(order?.createdAt).format("DD MMM YYYY, h:mm A")}
                </div>
              </div>
            </div>
            <button
              className="od-invoice-btn"
              onClick={() => navigate(`/order-invoice/${order?._id}`)}
            >
              <i className="ti ti-download" />
              Download Invoice
            </button>
          </div>

          {/* ── Main Grid ── */}
          <div className="od-grid">

            {/* ── LEFT COLUMN ── */}
            <div>

              {/* Products Card */}
              <div className="od-card" style={{ marginBottom: 20 }}>
                <div className="od-card-header">
                  <div className="od-card-title">
                    <div className="od-card-title-icon">
                      <i className="ti ti-shopping-bag" />
                    </div>
                    Order Items
                  </div>
                  <span style={{ fontSize: 12, color: "#828282" }}>
                    {products.length} item{products.length !== 1 ? "s" : ""}
                  </span>
                </div>

                <div style={{ overflowX: "auto" }}>
                  <table className="od-table">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>Price</th>
                        <th>Qty</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {products.map((item, i) => {
                        if (item.type === "product") {
                          const p = item?.productId;
                          const price = p?.discountedPrice || p?.price || 0;
                          return (
                            <tr key={`product-${i}`}>
                              <td>
                                <div className="od-prod-cell">
                                 <img src={getImageUrl(p?.productHeroImage)} alt="" className="od-prod-img" />
                                  <div>
                                    <div className="od-prod-name">{p?.name}</div>
                                    <span className="od-prod-tag">Product</span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="od-price-main">Rs {price}</div>
                                {p?.discountedPrice && (
                                  <div className="od-price-strike">Rs {p?.price}</div>
                                )}
                              </td>
                              <td><span className="od-qty-badge">{item?.quantity || 1}</span></td>
                              <td>
                                <span className="od-total-cell">
                                  Rs {(price * (item?.quantity || 1)).toFixed(2)}
                                </span>
                              </td>
                            </tr>
                          );
                        }
                        if (item.type === "comboProduct") {
                          const c = item?.comboProductId;
                          const price = c?.pricing?.comboPrice || 0;
                          return (
                            <tr key={`combo-${i}`}>
                              <td>
                                <div className="od-prod-cell">
                                 <img src={getImageUrl(c?.productHeroImage)} alt="" className="od-prod-img" />
                                  <div>
                                    <div className="od-prod-name">{c?.name}</div>
                                    <span className="od-prod-tag">Combo</span>
                                    <ul className="od-combo-items">
                                      {c?.productId?.map((po, idx) => (
                                        <li key={idx}>{po?.product?.name} ×{po?.quantity}</li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="od-price-main">Rs {price}</div>
                                {c?.pricing?.offerPrice && (
                                  <div className="od-price-strike">Rs {c?.pricing?.offerPrice}</div>
                                )}
                              </td>
                              <td><span className="od-qty-badge">{item?.quantity || 1}</span></td>
                              <td>
                                <span className="od-total-cell">
                                  Rs {(price * (item?.quantity || 1)).toFixed(2)}
                                </span>
                              </td>
                            </tr>
                          );
                        }
                        return null;
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Summary strip */}
                <div className="od-summary">
                  <div className="od-summary-row">
                    <span>Subtotal</span>
                    <span className="od-summary-val">Rs {order?.totalAmount}</span>
                  </div>
                  <div className="od-summary-row">
                    <span>Delivery Charge</span>
                    <span className="od-summary-val">Rs {order?.deliveryCharge || 0}</span>
                  </div>
                  <div className="od-summary-row total">
                    <span>Total Paid</span>
                    <span className="od-summary-val">Rs {totalPaid}</span>
                  </div>
                </div>
              </div>

              {/* Order Status Tracker */}
              <div className="od-card">
                <div className="od-card-header">
                  <div className="od-card-title">
                    <div className="od-card-title-icon">
                      <i className="ti ti-timeline" />
                    </div>
                    Order Status History
                  </div>
                </div>
                <div className="od-card-body">
                  <ul className="od-tracker">
                    {formattedStatusFlow?.map((step, idx) => (
                      <li key={idx} className="od-tracker-item">
                        <div className="od-tracker-icon">{step.icon}</div>
                        <div>
                          <div className="od-tracker-label">{step.label}</div>
                          <div className="od-tracker-date">{step.date}</div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* ── RIGHT COLUMN ── */}
            <div className="od-right-col">

              {/* Customer Details */}
              <div className="od-card">
                <div className="od-card-header">
                  <div className="od-card-title">
                    <div className="od-card-title-icon">
                      <i className="ti ti-user" />
                    </div>
                    Customer
                  </div>
                </div>
                <div className="od-card-body">
                  <div className="od-customer-top">
                    <img
                     src={getImageUrl(user?.profilePic) || "https://cdn-icons-png.flaticon.com/128/149/149071.png"}
                      alt="profile"
                      className="od-cust-avatar"
                    />
                    <div>
                      <div className="od-cust-name">{address?.fullName || "—"}</div>
                      <div className="od-cust-role">Customer</div>
                    </div>
                  </div>

                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-mail" /></div>
                    <div>
                      <div className="od-info-label">Email</div>
                      <div className="od-info-value">{user?.email || "—"}</div>
                    </div>
                  </div>
                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-phone" /></div>
                    <div>
                      <div className="od-info-label">Phone</div>
                      <div className="od-info-value od-mono">{user?.phone || "—"}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Shipping Address */}
              <div className="od-card">
                <div className="od-card-header">
                  <div className="od-card-title">
                    <div className="od-card-title-icon">
                      <i className="ti ti-map-pin" />
                    </div>
                    Shipping Address
                  </div>
                </div>
                <div className="od-card-body">
                  <span className="od-ship-chip">
                    <i className="ti ti-truck" style={{ fontSize: 13 }} />
                    {order?.shipping || "Standard"}
                  </span>

                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-user" /></div>
                    <div>
                      <div className="od-info-label">Name</div>
                      <div className="od-info-value">{address.fullName}</div>
                    </div>
                  </div>
                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-phone" /></div>
                    <div>
                      <div className="od-info-label">Phone</div>
                      <div className="od-info-value od-mono">{address.phone}</div>
                    </div>
                  </div>
                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-home" /></div>
                    <div>
                      <div className="od-info-label">Address</div>
                      <div className="od-info-value">
                        {address.area}, {address.city}, {address.state} – {address.pincode}
                      </div>
                    </div>
                  </div>
                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-world" /></div>
                    <div>
                      <div className="od-info-label">Country</div>
                      <div className="od-info-value">{address.country}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Payment Details */}
              <div className="od-card">
                <div className="od-card-header">
                  <div className="od-card-title">
                    <div className="od-card-title-icon">
                      <i className="ti ti-credit-card" />
                    </div>
                    Payment
                  </div>
                </div>
                <div className="od-card-body">
                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-hash" /></div>
                    <div>
                      <div className="od-info-label">Transaction ID</div>
                      <div className="od-info-value od-mono">#{order?.paymentId || "N/A"}</div>
                    </div>
                  </div>
                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-wallet" /></div>
                    <div>
                      <div className="od-info-label">Payment Mode</div>
                      <div className="od-info-value">{order?.modeOfPayment || "—"}</div>
                    </div>
                  </div>
                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-truck" /></div>
                    <div>
                      <div className="od-info-label">Delivery Charge</div>
                      <div className="od-info-value od-mono">Rs {order?.deliveryCharge || 0}</div>
                    </div>
                  </div>
                  <div className="od-info-row">
                    <div className="od-info-icon"><i className="ti ti-coins" /></div>
                    <div>
                      <div className="od-info-label">Total Paid</div>
                      <div className="od-info-value od-mono" style={{ color: "#a60808", fontWeight: 700, fontSize: 15 }}>
                        Rs {totalPaid}
                      </div>
                    </div>
                  </div>

                  {/* Screenshot row */}
                  <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f7f5f5", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div className="od-info-label" style={{ marginBottom: 6 }}>Payment Screenshot</div>
                      {isPaymentUploaded ? (
                        <span className="od-ss-badge up">
                          <i className="ti ti-circle-check" style={{ fontSize: 13 }} />
                          Uploaded
                        </span>
                      ) : (
                        <span className="od-ss-badge no">
                          <i className="ti ti-circle-x" style={{ fontSize: 13 }} />
                          Not Uploaded
                        </span>
                      )}
                    </div>
                    {isPaymentUploaded && (
                      <button
                        onClick={() => setShowPaymentModal(true)}
                        style={{
                          height: 34, padding: "0 14px", borderRadius: 9,
                          border: "1px solid #f0eded", background: "#fff",
                          fontSize: 12.5, color: "#555", cursor: "pointer",
                          display: "inline-flex", alignItems: "center", gap: 5,
                          transition: "all 0.18s",
                        }}
                        onMouseOver={e => { e.currentTarget.style.background = "#fdf2f1"; e.currentTarget.style.color = "#a60808"; }}
                        onMouseOut={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#555"; }}
                      >
                        <i className="ti ti-eye" /> View
                      </button>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Payment Screenshot Modal */}
      <Modal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} centered>
        <Modal.Header closeButton style={{ borderBottom: "1px solid #f0eded" }}>
          <Modal.Title style={{ fontSize: 15, fontWeight: 700, color: "#1c0a0a" }}>
            Payment Screenshot
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center" style={{ padding: 20 }}>
          <img
           src={getImageUrl(order?.paymentSs)}
            alt="Payment Screenshot"
            className="img-fluid rounded"
            style={{ borderRadius: 10 }}
          />
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "1px solid #f0eded" }}>
          <Button
            variant="secondary"
            onClick={() => setShowPaymentModal(false)}
            style={{
              background: "#1c0a0a", border: "none", borderRadius: 8,
              fontSize: 13, fontWeight: 600, padding: "8px 20px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OrderDetails;